export default __webpack_public_path__ + "static/media/XPGrey.14ce681f.svg";